module.exports = __webpack_public_path__ + "img/logo-250x70.e5d3e405.png";